<template>
  <div class="form" :class="{ 'form-loading': isLoading }">
    <div class="content-title">
      <h1 class="title">Instruções de preenchimento:</h1>
      <span class="line"></span>
    </div>
    <div class="intro-doc">
      <p>
        a) Os campos com asterisco são de preenchimento obrigatório por conterem
        informações necessárias para avaliação do caso clinico pelo médico
        consultor. Certifique-se de seu completo preenchimento.
      </p>
      <p>
        b) Somente após o completo preenchimento dos campos obrigatórios, o
        botão Submeter para Avaliação, que se encontra no final do formulário,
        será liberado (ficará verde) para o envio do caso clínico ao médico
        consultor.
      </p>
      <p>
        c) A qualquer momento você pode utilizar o botão Salvar, que se encontra
        no final de formulário, para gravar o seu trabalho em andamento e
        retomá-lo posteriormente.
      </p>
    </div>
    <input-group>
      <input-wrapper>
        <label>Idade. <span style="color: red; font-size: 20px">*</span></label>
        <el-input
          type="number"
          class="flexible-input"
          v-model="age"
          :disabled="!isEdit"
          min="0"
        />
        <p v-if="!age" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
      <input-wrapper>
        <label>Sexo. <span style="color: red; font-size: 20px">*</span></label>
        <el-select
          placeholder="Selecione"
          v-model="gender"
          size="large"
          filterable
          clearable
          :disabled="!isEdit"
        >
          <el-option
            v-for="item in genderOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!gender" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
      <input-wrapper>
        <label>Raça. <span style="color: red; font-size: 20px">*</span></label>
        <el-select
          placeholder="Selecione"
          v-model="color"
          size="large"
          filterable
          clearable
          :disabled="!isEdit"
        >
          <el-option
            v-for="item in colorOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :disabled="!isEdit"
          />
        </el-select>
        <p v-if="!color" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <div class="content-title">
      <h1 class="title">{{ titleAsthma }}</h1>
      <span class="line"></span>
    </div>
    <input-group>
      <input-wrapper>
        <label
          >O paciente tem diagnóstico de asma?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="asthma"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in asthmaOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!asthma" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Foram excluídas outras doenças pulmonares crônicas? (DPOC,
          bronquiectasias, fibrose cística, insuficiência cardíaca, etc.) ?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="lungDiseases"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in lungDiseasesOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!lungDiseases" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >A adesão ao tratamento está adequada? (Checar idealmente com contagem
          de doses do dispositivo entre as consultas).
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="asthmaTreatment"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in asthmaTreatmentOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!asthmaTreatment" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >A técnica inalatória está adequada? (Ideal checagem em 2-3
          consultas). <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="inhalation"
          :disabled="!isEdit"
          size="large"
          clearable
        >
          <el-option
            v-for="item in inhalationOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!inhalation" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <div class="content-title">
      <h1 class="title">{{ titleComorbidities }}</h1>
      <span class="line"></span>
    </div>
    <input-group>
      <input-wrapper>
        <label
          >Quais o paciente apresenta?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="comorbidities"
          :disabled="!isEdit"
          size="large"
          multiple
          clearable
        >
          <el-option
            v-for="item in comorbiditiesOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p
          v-if="this.comorbidities?.length === 0"
          style="color: red; margin-top: 8px;"
        >
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label>Outras comorbidades:</label>
        <el-input
          v-model="otherComorbidities"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="isOtherComorbiditiesDisabled || !isEdit"
        />
        <p
          v-if="!isOtherComorbiditiesDisabled"
          style="color: red; margin-top: 8px;"
        >
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Todas aquelas manejáveis estão adequadamente tratadas?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="comorbiditiesSelected"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in comorbiditiesSelectOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!comorbiditiesSelected" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label>Em caso positivo, descreva.</label>
        <el-input
          v-model="comorbiditiesInfo"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="comorbiditiesSelected !== 1 || !isEdit"
        />
        <p
          v-if="comorbiditiesSelected === 1"
          style="color: red; margin-top: 8px;"
        >
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >O paciente usa dose elevada de corticoide associado a LABA?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="laba"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in labaOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!laba" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Quais medicações para asma o paciente utiliza? (Incluir medicamentos,
          apresentação e posologia).
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="asthmaMedications"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="!isEdit"
        />
        <p v-if="!asthmaMedications" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >O paciente fez/faz uso de imunobiológico(s)?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="immunobiological"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in immunobiologicalOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!immunobiological" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label>Em caso positivo, descreva o medicamento e tempo de uso.</label>
        <el-input
          v-model="immunobiologicalDescription"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="immunobiological !== 1 || !isEdit"
        />
        <p v-if="immunobiological === 1" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <div class="content-title">
      <h1 class="title">{{ titleExams }}</h1>
      <span class="line"></span>
    </div>
    <div class="content-subtitle">
      <h2 class="title">
        {{ subtitleEspiro }}
        <span style="color: red; font-size: 20px">*</span>
      </h2>
    </div>
    <input-group>
      <input-wrapper>
        <el-input
          type="text"
          placeholder="Data _/_/__"
          class="flexible-input"
          v-model="espiroDate"
          v-mask="'##/##/####'"
          :disabled="!isEdit"
        />
        <p v-if="!espiroDate" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <div class="content-subtitle">
      <h2 class="title">
        Pré-BD.<span style="color: red; font-size: 20px">*</span>
      </h2>
    </div>
    <input-group>
      <input-wrapper>
        <el-input
          v-model="preCvf"
          placeholder="__%"
          :disabled="!isEdit"
          @keydown="handleKeyDown"
          @blur="verifyPreCvf"
        >
          <template #prepend><span v-html="cvf"/></template>
        </el-input>
      </input-wrapper>
      <input-wrapper>
        <el-input
          v-model="preVef"
          placeholder="__%"
          :disabled="!isEdit"
          @keydown="handleKeyDown"
          @blur="verifyPreVef"
        >
          <template #prepend><span v-html="vef"/></template>
        </el-input>
      </input-wrapper>
      <input-wrapper>
        <el-input
          v-model="preVefCvf"
          placeholder="__%"
          @keydown="handleKeyDown"
          :disabled="!isEdit"
          @blur="verifyPreVefCvf"
        >
          <template #prepend><span v-html="vefCvf"/></template>
        </el-input>
      </input-wrapper>
      <input-wrapper>
        <el-input
          v-model="preFef"
          placeholder="__%"
          @keydown="handleKeyDown"
          :disabled="!isEdit"
          @blur="verifyPreFef"
        >
          <template #prepend><span v-html="fef"/></template>
        </el-input>
      </input-wrapper>
    </input-group>
    <p
      v-if="!preVefCvf || !preVef || !preCvf"
      style="color: red; margin-top: 8px;"
    >
      Campo é obrigatório
    </p>
    <div class="content-subtitle">
      <h2 class="title">
        Pós-BD.<span style="color: red; font-size: 20px">*</span>
      </h2>
    </div>
    <input-group>
      <input-wrapper>
        <el-input
          v-model="posCvf"
          placeholder="__%"
          @keydown="handleKeyDown"
          :disabled="!isEdit"
          @blur="verifyPosCvf"
        >
          <template #prepend><span v-html="cvf"/></template>
        </el-input>
      </input-wrapper>
      <input-wrapper>
        <el-input
          v-model="posVef"
          placeholder="__%"
          @keydown="handleKeyDown"
          :disabled="!isEdit"
          @blur="verifyPosVef"
        >
          <template #prepend><span v-html="vef"/></template>
        </el-input>
      </input-wrapper>
      <input-wrapper>
        <el-input
          v-model="posVefCvf"
          placeholder="__%"
          @keydown="handleKeyDown"
          :disabled="!isEdit"
          @blur="verifyPosVefCvf"
        >
          <template #prepend><span v-html="vefCvf"/></template>
        </el-input>
      </input-wrapper>
      <input-wrapper>
        <el-input
          v-model="posFef"
          placeholder="__%"
          @keydown="handleKeyDown"
          :disabled="!isEdit"
          @blur="verifyPosFef"
        >
          <template #prepend><span v-html="fef"/></template>
        </el-input>
      </input-wrapper>
    </input-group>
    <p
      v-if="!posVefCvf || !posVef || !posCvf"
      style="color: red; margin-top: 8px;"
    >
      Campo é obrigatório
    </p>
    <input-group>
      <input-wrapper>
        <label>
          Resposta ao BD: __%
          <span style="color: red; font-size: 20px">*</span>
        </label>
        <el-input
          type="text"
          placeholder="__%"
          class="flexible-input"
          v-model="bd"
          @keydown="handleKeyDown"
          :disabled="!isEdit"
          @blur="verifyBd"
        />
        <p v-if="!bd" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Laudo: Texto da conclusão do laudo.
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="report"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="!isEdit"
        />
        <p v-if="!report" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Eosinófilos no sangue: __céls/mm&sup3;.
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="eosinophilsBlood"
          :placeholder="`__céls/mm&sup3;`"
          type="text"
          :disabled="!isEdit"
          @keydown="handleKeyDown"
          @blur="verifyEosinophilsBlood"
        />
        <p v-if="!eosinophilsBlood" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
      <input-wrapper>
        <label>Eosinófilos no escarro: __% (se realizado)</label>
        <el-input
          v-model="eosinophilsSputum"
          placeholder="__%"
          type="text"
          :disabled="!isEdit"
          @keydown="handleKeyDown"
          @blur="verifyEosinophilsSputum"
        />
      </input-wrapper>
    </input-group>
    <div class="content-subtitle">
      <h2 class="title">Sensibilização a alérgenos:</h2>
    </div>
    <input-group>
      <input-wrapper>
        <label
          >Teste cutâneo?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="skinTest"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in skinOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!skinTest" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >IgE específica no sangue.
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="ige"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in igeOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!ige" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Quais alérgenos foram testados e quais deram positivos?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="allergens"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="!isEdit"
        />
        <p v-if="!allergens" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >IgE total: __ UI/ml
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-input
          v-model="igeTotal"
          placeholder="__ UI/ml"
          type="text"
          :disabled="!isEdit"
          @keydown="handleKeyDown"
          @blur="verifyIgeTotal"
        />
        <p v-if="!igeTotal" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
      <input-wrapper>
        <label>FeNO: __ ppm (se realizado)</label>
        <el-input
          v-model="FeNO"
          type="text"
          placeholder="__ ppm"
          :disabled="!isEdit"
          @keydown="handleKeyDown"
          @blur="verifyFeNO"
        />
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label>Pletismografia (se realizado):</label>
        <el-input
          v-model="plethysmography"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="!isEdit"
        />
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label>Difusão de monóxido de carbono (DLCO) (se realizado):</label>
        <el-input
          v-model="dlco"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="!isEdit"
        />
      </input-wrapper>
    </input-group>
    <input-group>
      <!-- <input-wrapper>
          <form @submit.prevent="submit" enctype="multipart/form-data">
            <input
              id="actionsNewAsset"
              ref="file"
              type="file"
              name="file"
              class="att__search-input"
              accept="image/png, image/gif, image/jpg, image/jpeg, .pdf"
              @change="handleFile"
            />
            <button type="submit">Enviar Arquivo</button>
          </form>
        </input-wrapper> -->
      <input-wrapper class="clinical-case-upload">
        <label
          >TC de tórax (fazer upload de imagem e laudo, se realizado).</label
        >
        <el-upload
          v-model="fileList"
          class="upload-demo"
          :auto-upload="false"
          @change="handleFileImg"
          :disabled="!isEdit"
          :show-file-list="false"
        >
          <template #trigger>
            <el-input type="text" :suffix-icon="iconImg" />
          </template>
        </el-upload>

        <p
          v-if="Object.keys(selectedFile).length > 0"
          style="color: red; margin-top: 8px;"
        >
          Reiteramos que os arquivos enviados não podem conter dados pessoais,
          sensíveis ou não, que identifiquem ou possam identificar o paciente.
        </p>

        <div class="filepath" v-for="file in getFile" :key="file.id">
          <PictureFilled style="width: 1em; height: 1em; margin-right: 8px" />
          <p @click="handleDownload(file.id, file.fileName)" class="filename">
            {{ file.fileName }}
          </p>
        </div>
      </input-wrapper>
    </input-group>
    <div class="content-title">
      <h1 class="title">Outras informações</h1>
      <span class="line"></span>
    </div>
    <div class="content-subtitle">
      <h2 class="title">
        Início da doença com que idade
        <span style="color: red; font-size: 20px">*</span>
      </h2>
    </div>
    <input-group>
      <input-wrapper>
        <label>Anos: <span style="color: red; font-size: 20px">*</span></label>
        <el-input
          v-model="ageStart"
          type="number"
          min="0"
          :disabled="!isEdit"
        />
        <p v-if="!ageStart" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
      <input-wrapper>
        <label>Meses: <span style="color: red; font-size: 20px">*</span></label>
        <el-input
          v-model="ageMonthStart"
          type="number"
          min="0"
          max="12"
          :disabled="!isEdit"
          @blur="verifyAgeMonthStart"
        />
        <p v-if="!ageMonthStart" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <div class="content-subtitle">
      <h2 class="title">Controle ambiental.</h2>
    </div>
    <input-group>
      <input-wrapper>
        <label
          >Tem muita poeira doméstica em casa?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="dust"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in dustOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!dust" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Animais em casa?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="pet"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in petOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!pet" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
      <input-wrapper>
        <label
          >Descreva o(s) tipo(s) de animal(is). Ex.: cachorro, gato, ave,
          etc.</label
        >
        <el-input
          v-model="petDescription"
          type="text"
          min="0"
          :disabled="pet !== 1 || !isEdit"
        />
        <p v-if="pet === 1" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Mofo no domicílio?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="mold"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in moldOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!mold" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Exposição ocupacional.
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="exhibition"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in exhibitionOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!exhibition" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
      <input-wrapper>
        <label>Quais?</label>
        <el-input
          v-model="exhibitionDescription"
          type="text"
          min="0"
          :disabled="exhibition !== 1 || !isEdit"
        />
        <p v-if="exhibition === 1" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Exacerbação com uso de corticoide oral nos últimos 12 meses?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="corticosteroid"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in corticosteroidOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!corticosteroid" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
      <input-wrapper>
        <label>Quantas vezes?</label>
        <el-input
          v-model="corticosteroidTimes"
          type="number"
          min="0"
          :disabled="corticosteroid !== 1 || !isEdit"
        />
        <p v-if="corticosteroid === 1" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Hospitalização nos últimos 12 meses?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="hospitalization"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in hospitalizationOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!hospitalization" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
      <input-wrapper>
        <label>Quantas vezes?</label>
        <el-input
          v-model="hospitalizationTimes"
          type="number"
          min="0"
          :disabled="hospitalization !== 1 || !isEdit"
        />
        <p v-if="hospitalization === 1" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Histórico de internação em UTI?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="uti"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in utiOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!uti" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
      <input-wrapper>
        <label>Quantas vezes?</label>
        <el-input
          v-model="utiTimes"
          type="number"
          min="0"
          :disabled="uti !== 1 || !isEdit"
        />
        <p v-if="uti === 1" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Histórico de necessidade de Ventilação Mecânica?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="ventilation"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in ventilationOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!ventilation" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
      <input-wrapper>
        <label>Quantas vezes?</label>
        <el-input
          v-model="ventilationTimes"
          type="number"
          min="0"
          :disabled="ventilation !== 1 || !isEdit"
        />
        <p v-if="ventilation === 1" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Histórico de PCR?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="pcr"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in pcrOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!pcr" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
      <input-wrapper>
        <label>Quantas vezes?</label>
        <el-input
          v-model="pcrTimes"
          type="number"
          min="0"
          :disabled="pcr !== 1 || !isEdit"
        />
        <p v-if="pcr === 1" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Fumante ativo?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="activeSmoking"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in activeSmokingOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!activeSmoking" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Fumante passivo?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="passiveSmoking"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in passiveSmokingOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!passiveSmoking" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label
          >Uso de outras medicações?
          <span style="color: red; font-size: 20px">*</span></label
        >
        <el-select
          placeholder="Selecione"
          v-model="medications"
          size="large"
          :disabled="!isEdit"
          clearable
        >
          <el-option
            v-for="item in medicationsOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
        <p v-if="!medications" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p></input-wrapper
      >
    </input-group>
    <input-group>
      <input-wrapper>
        <label>Descreva...</label>
        <el-input
          v-model="medicationsDescription"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="medications !== 1 || !isEdit"
        />
        <p v-if="medications === 1" style="color: red; margin-top: 8px;">
          Campo é obrigatório
        </p>
      </input-wrapper>
    </input-group>
    <div class="content-title">
      <h1 class="title">
        Observações Adicionais e Dúvidas.
      </h1>
      <span class="line"></span>
    </div>
    <input-group>
      <input-wrapper>
        <label
          >Observações adicionais (inclua aqui informações adicionais que julgar
          relevante para apresentação do seu caso clínico).</label
        >
        <el-input
          v-model="observations"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="!isEdit"
        />
        <label>Perguntas ou dúvidas principais sobre o seu caso clínico.</label>
        <el-input
          v-model="questionsOrDoubts"
          :autosize="{ minRows: 4, maxRows: 4 }"
          type="textarea"
          :disabled="!isEdit"
        />
      </input-wrapper>
    </input-group>

    <div v-if="!isEdit" class="exams">
      <div class="content-title">
        <h1 class="title">Exames e Laudos Adicionais</h1>
        <span class="line"></span>
      </div>
      <div class="filepath" v-for="file in getFile" :key="file.id">
        <PictureFilled style="width: 1em; height: 1em; margin-right: 8px" />
        <p @click="handleDownload(file.id, file.fileName)" class="filename">
          {{ file.fileName }}
        </p>
      </div>
    </div>

    <div class="btn" v-if="isEdit">
      <el-button class="save" type="primary" @click="handleSave"
        >Salvar</el-button
      >
      <el-button
        class="send"
        type="primary"
        :disabled="handleEnabledSubmit"
        @click="handleActiveVoucher"
        >Submeter para avaliação</el-button
      >
    </div>
  </div>
</template>

<script>
import { PictureFilled } from '@element-plus/icons-vue'
import axios from 'axios'
import { useToast } from 'vue-toastification'
import { mapGetters, mapActions } from 'vuex'

import InputGroup from '@/components/inputGroup'
import InputWrapper from '@/components/inputWrapper'
import router from '@/router'

export default {
  name: 'AsmaGraveForm',
  components: {
    InputGroup,
    InputWrapper,
    PictureFilled
  },
  props: {
    voucherId: {
      type: Number,
      required: true
    }
  },
  setup() {
    const toast = useToast()
    return { toast }
  },
  data() {
    return {
      iconImg: PictureFilled,
      titleAsthma: 'Diagnóstico de Asma Grave',
      asthma: null,
      asthmaOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      lungDiseases: null,
      lungDiseasesOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      asthmaTreatment: null,
      asthmaTreatmentOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      inhalation: null,
      inhalationOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      error: null,
      isModalDashedErroVisible: false,
      titleComorbidities: 'Em relação a potenciais comorbidades.',
      comorbidities: null,
      comorbiditiesOptions: [
        {
          id: 1,
          name: 'Nenhuma.'
        },
        {
          id: 2,
          name: 'Rinite alérgica.'
        },
        {
          id: 3,
          name: 'Dermatite atópica.'
        },
        {
          id: 4,
          name: 'Sinusopatia crônica com polipose nasal.'
        },
        {
          id: 6,
          name: 'Obesidade.'
        },
        {
          id: 7,
          name: 'Apneia obstrutiva do sono.'
        },
        {
          id: 8,
          name: 'Refluxo gastroesofágico.'
        },
        {
          id: 9,
          name: 'Hipertensão arterial sistêmica.'
        },
        {
          id: 10,
          name: 'Diabetes.'
        },
        {
          id: 11,
          name: 'Outras.'
        }
      ],
      otherComorbidities: null,
      comorbiditiesInfo: null,
      comorbiditiesSelected: null,
      comorbiditiesSelectOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      laba: null,
      labaOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      asthmaMedications: null,
      immunobiological: null,
      immunobiologicalOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      immunobiologicalDescription: null,
      titleExams: 'Exames adicionais',
      subtitleEspiro: 'Espirometria (último exame realizado)',
      espiroDate: null,
      preCvf: null,
      preVef: null,
      preVefCvf: null,
      preFef: null,
      posCvf: null,
      posVef: null,
      posVefCvf: null,
      posFef: null,
      bd: null,
      report: null,
      eosinophilsBlood: null,
      eosinophilsSputum: null,
      skinTest: null,
      skinOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      ige: null,
      igeOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      allergens: null,
      igeTotal: null,
      FeNO: null,
      plethysmography: null,
      dlco: null,
      ageStart: null,
      ageMonthStart: null,
      dust: null,
      dustOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      pet: null,
      petOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      petDescription: null,
      mold: null,
      moldOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      exhibition: null,
      exhibitionOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      exhibitionDescription: null,
      activeSmoking: null,
      activeSmokingOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      passiveSmoking: null,
      passiveSmokingOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      corticosteroid: null,
      corticosteroidOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      corticosteroidTimes: null,
      hospitalization: null,
      hospitalizationOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      hospitalizationTimes: null,
      uti: null,
      utiOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      utiTimes: null,
      ventilation: null,
      ventilationOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      ventilationTimes: null,
      pcr: null,
      pcrOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      pcrTimes: null,
      medications: null,
      medicationsOptions: [
        {
          id: 1,
          name: 'Sim.'
        },
        {
          id: 2,
          name: 'Não.'
        }
      ],
      medicationsDescription: null,
      observations: null,
      questionsOrDoubts: null,
      gender: null,
      genderOptions: [
        {
          id: 2,
          name: 'Feminino.'
        },
        {
          id: 1,
          name: 'Masculino.'
        }
      ],
      age: null,
      color: null,
      colorOptions: [
        {
          id: 1,
          name: 'Branca.'
        },
        {
          id: 2,
          name: 'Preta.'
        },
        {
          id: 3,
          name: 'Parda.'
        },
        {
          id: 4,
          name: 'Amarela.'
        },
        {
          id: 5,
          name: 'Indígena.'
        }
      ],
      selectedFile: {},
      fileImg: null
    }
  },
  created() {
    if (!this.getVoucher.id) return router.push('/')
  },
  mounted() {
    this.offActiveVoucherPage()
    this.fetchVoucher(this.getVoucher.id)
    this.verifyIsEdit(this.getVoucherInfos)
  },
  watch: {
    getVoucherInfos() {
      this.verifyIsEdit(this.getVoucherInfos)
      this.handleData()
    },
    comorbidities() {
      if (!this.comorbidities?.includes(11))
        return this.clearOtherComorbidities()
    },

    immunobiological() {
      if (this.immunobiological === 2)
        return this.clearImmunobiologicalDescription()
    },

    pet() {
      if (this.pet === 2) return this.clearPetDescription()
    },

    exhibition() {
      if (this.exhibition === 2) return this.clearExhibitionDescription()
    },

    corticosteroid() {
      if (this.corticosteroid === 2) return (this.corticosteroidTimes = null)
    },

    hospitalization() {
      if (this.hospitalization === 2) return (this.hospitalizationTimes = null)
    },

    uti() {
      if (this.uti === 2) return (this.utiTimes = null)
    },

    ventilation() {
      if (this.ventilation === 2) return (this.ventilationTimes = null)
    },

    pcr() {
      if (this.pcr === 2) return (this.pcrTimes = null)
    },

    medications() {
      if (this.medications === 2) return (this.medicationsDescription = null)
    }
  },
  computed: {
    ...mapGetters(['getUserToken']),
    ...mapGetters('clinicalCasesEvaluation', [
      'getVoucher',
      'getActiveDisease'
    ]),
    ...mapGetters('activeClinicalCases', [
      'getLoading',
      'getVoucherInfos',
      'getFile'
    ]),

    isConsultant() {
      // Recuperar o tipo do localStorage
      const type = localStorage.getItem('user')
        ? JSON.parse(localStorage.getItem('user')).type
        : null

      // Retornar o tipo, ou uma string padrão se não. estiver definido
      return type || 'Tipo não. definido'
    },

    isOtherComorbiditiesDisabled() {
      return !this.comorbidities?.includes(11)
    },

    cvf() {
      return 'CVF <sub style="vertical-align: sub;font-size: 70%">1</sub> <span style="color: red; font-size: 20px">*</span>'
    },

    vef() {
      return 'VEF <sub style="vertical-align: sub;font-size: 70%">1</sub> <span style="color: red; font-size: 20px">*</span>'
    },

    vefCvf() {
      return 'VEF <sub style="vertical-align: sub;font-size: 70%">1</sub>/CVF <span style="color: red; font-size: 20px">*</span>'
    },

    fef() {
      return 'FEF <sub style="vertical-align: sub;font-size: 70%">25% - 75%</sub>'
    },

    isLoading() {
      return this.getLoading
    },

    isEdit() {
      if (this.isConsultant === 'consultant_doctor') return false
      if (
        this.getVoucherInfos.length !== 0 &&
        this.getVoucherInfos?.status !== 'aloc'
      )
        return false
      return true
    },

    verifyOtherComorbidities() {
      if (this.isOtherComorbiditiesDisabled) return !this.otherComorbidities
      else return this.otherComorbidities
    },

    verifyImmunobiologicalDescription() {
      if (this.immunobiological === 2) return !this.immunobiologicalDescription
      else return this.immunobiologicalDescription
    },

    verifyPet() {
      if (this.pet === 2) return !this.petDescription
      else return this.petDescription
    },

    verifyExhibition() {
      if (this.exhibition === 2) return !this.exhibitionDescription
      else return this.exhibitionDescription
    },

    verifyCorticosteroid() {
      if (this.corticosteroid === 2) return !this.corticosteroidTimes
      else return this.corticosteroidTimes
    },

    verifyHospitalization() {
      if (this.hospitalization === 2) return !this.hospitalizationTimes
      else return this.hospitalizationTimes
    },

    verifyTimes() {
      if (this.uti === 2) return !this.utiTimes
      else return this.utiTimes
    },

    verifyVentilation() {
      if (this.ventilation === 2) return !this.ventilationTimes
      else return this.ventilationTimes
    },

    verifyPcr() {
      if (this.pcr === 2) return !this.pcrTimes
      else return this.pcrTimes
    },

    verifyMedications() {
      if (this.medications === 2) return !this.medicationsDescription
      else return this.medicationsDescription
    },

    handleEnabledSubmit() {
      return (
        !this.age ||
        !this.gender ||
        !this.color ||
        !this.asthma ||
        !this.lungDiseases ||
        !this.asthmaTreatment ||
        !this.inhalation ||
        !this.comorbidities ||
        !this.verifyOtherComorbidities ||
        !this.laba ||
        !this.espiroDate ||
        !this.asthmaMedications ||
        !this.immunobiological ||
        !this.verifyImmunobiologicalDescription ||
        !this.preCvf ||
        !this.preVef ||
        !this.preVefCvf ||
        !this.posCvf ||
        !this.posVef ||
        !this.posVefCvf ||
        !this.bd ||
        !this.report ||
        !this.eosinophilsBlood ||
        !this.skinTest ||
        !this.ige ||
        !this.allergens ||
        !this.igeTotal ||
        !this.ageStart ||
        !this.ageMonthStart ||
        !this.dust ||
        !this.pet ||
        !this.verifyPet ||
        !this.mold ||
        !this.exhibition ||
        !this.verifyExhibition ||
        !this.activeSmoking ||
        !this.passiveSmoking ||
        !this.corticosteroid ||
        !this.verifyCorticosteroid ||
        !this.hospitalization ||
        !this.verifyHospitalization ||
        !this.uti ||
        !this.verifyTimes ||
        !this.ventilation ||
        !this.verifyVentilation ||
        !this.pcr ||
        !this.verifyPcr ||
        !this.medications ||
        !this.verifyMedications ||
        !this.comorbiditiesSelected
      )
    }
  },
  methods: {
    ...mapActions('activeClinicalCases', [
      'fechVoucherDownload',
      'saveEditVoucher',
      'activeVoucher',
      'fetchVoucher',
      'fetchFile'
    ]),
    ...mapActions('clinicalCasesEvaluation', ['offActiveVoucherPage']),

    handleKeyDown(event) {
      // Permite apenas entrada numérica, a tecla Backspace, Tab e ações de cursor
      const isNumeric = /^[0-9]$/.test(event.key)
      const isBackspace = event.key === 'Backspace'
      const isTab = event.key === 'Tab'
      const isCursorAction =
        event.key.startsWith('Arrow') ||
        event.key.startsWith('Home') ||
        event.key.startsWith('End')

      if (!(isNumeric || isBackspace || isTab || isCursorAction)) {
        event.preventDefault()
      }
    },
    verifyPreCvf() {
      // Remove caracteres não numéricos e garante que o valor seja um número
      let numericValue = parseFloat(this.preCvf?.replace(/[^0-9]/g, ''))

      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.preCvf = `${numericValue}%`
    },

    clearOtherComorbidities() {
      this.otherComorbidities = null
    },

    clearImmunobiologicalDescription() {
      this.immunobiologicalDescription = null
    },

    clearPetDescription() {
      this.petDescription = null
    },

    clearExhibitionDescription() {
      this.exhibitionDescription = null
    },

    // verifyPreCvf() {
    //   if (parseInt(this.preCvf) > 100) return (this.preCvf = '100%')
    // },

    verifyPreVef() {
      let numericValue = parseFloat(this.preVef?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.preVef = `${numericValue}%`
    },

    verifyPreVefCvf() {
      let numericValue = parseFloat(this.preVefCvf?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.preVefCvf = `${numericValue}%`
    },

    verifyPreFef() {
      if (!this.preFef) return

      let numericValue = parseFloat(this.preFef?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.preFef = `${numericValue}%`
    },

    verifyPosCvf() {
      let numericValue = parseFloat(this.posCvf?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.posCvf = `${numericValue}%`
    },

    verifyAgeMonthStart() {
      if (this.ageMonthStart > 12) return (this.ageMonthStart = 12)
    },

    verifyPosVef() {
      let numericValue = parseFloat(this.posVef?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.posVef = `${numericValue}%`
    },

    verifyPosVefCvf() {
      let numericValue = parseFloat(this.posVefCvf?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.posVefCvf = `${numericValue}%`
    },

    verifyPosFef() {
      if (!this.posFef) return

      let numericValue = parseFloat(this.posFef?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.posFef = `${numericValue}%`
    },

    verifyBd() {
      let numericValue = parseFloat(this.bd?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.bd = `${numericValue}%`
    },

    verifyEosinophilsBlood() {
      let numericValue = parseFloat(
        this.eosinophilsBlood?.replace(/[^0-9]/g, '')
      )
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Atualiza o valor formatado
      this.eosinophilsBlood = `${numericValue}céls/mm³`
    },

    verifyEosinophilsSputum() {
      let numericValue = parseFloat(
        this.eosinophilsSputum?.replace(/[^0-9]/g, '')
      )
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Garante que o valor não ultrapasse 100
      numericValue = Math.min(100, numericValue)

      // Atualiza o valor formatado
      this.eosinophilsSputum = `${numericValue}%`
    },

    verifyIgeTotal() {
      let numericValue = parseFloat(this.igeTotal?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Atualiza o valor formatado
      this.igeTotal = `${numericValue}UI/ml`
    },

    verifyFeNO() {
      let numericValue = parseFloat(this.FeNO?.replace(/[^0-9]/g, ''))
      if (isNaN(numericValue)) {
        numericValue = 0
      }

      // Atualiza o valor formatado
      this.FeNO = `${numericValue}ppm`
    },

    handleDownload(id, name) {
      const fileData = {
        id: id,
        name: name
      }
      this.fechVoucherDownload(fileData)
    },

    goBack() {
      if (this.isConsultant === 'consultant_doctor')
        return router.push('/clinical-cases-consultation-doctor')
      else router.push('/clinical-cases-evaluation')
    },

    handleSave() {
      const userData = {
        data: JSON.stringify({
          age: this.age,
          gender: this.gender,
          color: this.color,
          asthma: this.asthma,
          lungDiseases: this.lungDiseases,
          asthmaTreatment: this.asthmaTreatment,
          comorbiditiesSelected: this.comorbiditiesSelected,
          inhalation: this.inhalation,
          comorbidities: this.comorbidities,
          otherComorbidities: this.otherComorbidities,
          comorbiditiesInfo: this.comorbiditiesInfo,
          laba: this.laba,
          asthmaMedications: this.asthmaMedications,
          immunobiological: this.immunobiological,
          immunobiologicalDescription: this.immunobiologicalDescription,
          espiroDate: this.espiroDate,
          preCvf: this.preCvf,
          preVef: this.preVef,
          preVefCvf: this.preVefCvf,
          preFef: this.preFef,
          posCvf: this.posCvf,
          posVef: this.posVef,
          posVefCvf: this.posVefCvf,
          posFef: this.posFef,
          bd: this.bd,
          report: this.report,
          eosinophilsBlood: this.eosinophilsBlood,
          eosinophilsSputum: this.eosinophilsSputum,
          skinTest: this.skinTest,
          ige: this.ige,
          allergens: this.allergens,
          igeTotal: this.igeTotal,
          FeNO: this.FeNO,
          plethysmography: this.plethysmography,
          dlco: this.dlco,
          ageStart: this.ageStart,
          ageMonthStart: this.ageMonthStart,
          dust: this.dust,
          pet: this.pet,
          petDescription: this.petDescription,
          mold: this.mold,
          exhibition: this.exhibition,
          exhibitionDescription: this.exhibitionDescription,
          activeSmoking: this.activeSmoking,
          passiveSmoking: this.passiveSmoking,
          corticosteroid: this.corticosteroid,
          corticosteroidTimes: this.corticosteroidTimes,
          hospitalization: this.hospitalization,
          hospitalizationTimes: this.hospitalizationTimes,
          uti: this.uti,
          utiTimes: this.utiTimes,
          ventilation: this.ventilation,
          ventilationTimes: this.ventilationTimes,
          pcr: this.pcr,
          pcrTimes: this.pcrTimes,
          medications: this.medications,
          medicationsDescription: this.medicationsDescription,
          observations: this.observations,
          questionsOrDoubts: this.questionsOrDoubts
        }),
        voucherId: this.getVoucher.id
      }
      this.saveEditVoucher(userData)
    },

    handleActiveVoucher() {
      const userData = {
        data: JSON.stringify({
          age: this.age,
          gender: this.gender,
          color: this.color,
          asthma: this.asthma,
          lungDiseases: this.lungDiseases,
          asthmaTreatment: this.asthmaTreatment,
          comorbiditiesSelected: this.comorbiditiesSelected,
          inhalation: this.inhalation,
          comorbidities: this.comorbidities,
          otherComorbidities: this.otherComorbidities,
          comorbiditiesInfo: this.comorbiditiesInfo,
          laba: this.laba,
          asthmaMedications: this.asthmaMedications,
          immunobiological: this.immunobiological,
          immunobiologicalDescription: this.immunobiologicalDescription,
          espiroDate: this.espiroDate,
          preCvf: this.preCvf,
          preVef: this.preVef,
          preVefCvf: this.preVefCvf,
          preFef: this.preFef,
          posCvf: this.posCvf,
          posVef: this.posVef,
          posVefCvf: this.posVefCvf,
          posFef: this.posFef,
          bd: this.bd,
          report: this.report,
          eosinophilsBlood: this.eosinophilsBlood,
          eosinophilsSputum: this.eosinophilsSputum,
          skinTest: this.skinTest,
          ige: this.ige,
          allergens: this.allergens,
          igeTotal: this.igeTotal,
          FeNO: this.FeNO,
          plethysmography: this.plethysmography,
          dlco: this.dlco,
          ageStart: this.ageStart,
          ageMonthStart: this.ageMonthStart,
          dust: this.dust,
          pet: this.pet,
          petDescription: this.petDescription,
          mold: this.mold,
          exhibition: this.exhibition,
          exhibitionDescription: this.exhibitionDescription,
          activeSmoking: this.activeSmoking,
          passiveSmoking: this.passiveSmoking,
          corticosteroid: this.corticosteroid,
          corticosteroidTimes: this.corticosteroidTimes,
          hospitalization: this.hospitalization,
          hospitalizationTimes: this.hospitalizationTimes,
          uti: this.uti,
          utiTimes: this.utiTimes,
          ventilation: this.ventilation,
          ventilationTimes: this.ventilationTimes,
          pcr: this.pcr,
          pcrTimes: this.pcrTimes,
          medications: this.medications,
          medicationsDescription: this.medicationsDescription,
          observations: this.observations,
          questionsOrDoubts: this.questionsOrDoubts
        }),
        voucherId: this.getVoucher.id
      }
      this.activeVoucher(userData)
      this.fetchVoucher(this.voucherId)
      this.verifyIsEdit(this.getVoucherInfos)
    },

    handleFile(event) {
      this.selectedFile = event.target.files[0]
    },

    async handleFileImg(file) {
      this.selectedFile = file.raw

      await this.submit()
    },

    async submit() {
      const url = process.env.VUE_APP_CLINICAL_CASE_API
      const voucherId = this.getVoucher.id
      const formData = new FormData()
      formData.append('body', this.selectedFile)

      await axios
        .post(`${url}/voucher/${voucherId}/document`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.getUserToken}`
          }
        })
        .then(() => {
          this.toast.success('Upload realizado com sucesso', {
            timeout: 8000
          })
        })
        .catch(() => {
          this.toast.warning('Não. foi possível realizar o upload do arquivo')
        })
        .finally(() => {
          this.fetchFile(voucherId)
        })
    },

    verifyIsEdit(getVoucherInfos) {
      if (getVoucherInfos?.status === 'ativ') return
      return (this.isEdit = true)
    },

    handleData() {
      const questionnaire = this.getVoucherInfos.questionnaire
      if (!questionnaire) return

      const jsonString = questionnaire
      const jsonObject = JSON.parse(jsonString.replace(/'/g, '"'))

      this.age = jsonObject?.age
      this.gender = jsonObject?.gender
      this.color = jsonObject?.color
      this.asthma = jsonObject?.asthma
      this.lungDiseases = jsonObject?.lungDiseases
      this.asthmaTreatment = jsonObject?.asthmaTreatment
      this.comorbiditiesSelected = jsonObject?.comorbiditiesSelected
      this.inhalation = jsonObject?.inhalation
      this.comorbidities = jsonObject?.comorbidities
      this.otherComorbidities = jsonObject?.otherComorbidities
      this.comorbiditiesInfo = jsonObject?.comorbiditiesInfo
      this.laba = jsonObject?.laba
      this.asthmaMedications = jsonObject?.asthmaMedications
      this.immunobiological = jsonObject?.immunobiological
      this.immunobiologicalDescription = jsonObject?.immunobiologicalDescription
      this.espiroDate = jsonObject?.espiroDate
      this.preCvf = jsonObject?.preCvf
      this.preVef = jsonObject?.preVef
      this.preVefCvf = jsonObject?.preVefCvf
      this.preFef = jsonObject?.preFef
      this.posCvf = jsonObject?.posCvf
      this.posVef = jsonObject?.posVef
      this.posVefCvf = jsonObject?.posVefCvf
      this.posFef = jsonObject?.posFef
      this.bd = jsonObject?.bd
      this.report = jsonObject?.report
      this.eosinophilsBlood = jsonObject?.eosinophilsBlood
      this.eosinophilsSputum = jsonObject?.eosinophilsSputum
      this.skinTest = jsonObject?.skinTest
      this.ige = jsonObject?.ige
      this.allergens = jsonObject?.allergens
      this.igeTotal = jsonObject?.igeTotal
      this.FeNO = jsonObject?.FeNO
      this.plethysmography = jsonObject?.plethysmography
      this.dlco = jsonObject?.dlco
      this.ageStart = jsonObject?.ageStart
      this.ageMonthStart = jsonObject?.ageMonthStart
      this.dust = jsonObject?.dust
      this.pet = jsonObject?.pet
      this.petDescription = jsonObject?.petDescription
      this.mold = jsonObject?.mold
      this.exhibition = jsonObject?.exhibition
      this.exhibitionDescription = jsonObject?.exhibitionDescription
      this.activeSmoking = jsonObject?.activeSmoking
      this.passiveSmoking = jsonObject?.passiveSmoking
      this.corticosteroid = jsonObject?.corticosteroid
      this.corticosteroidTimes = jsonObject?.corticosteroidTimes
      this.hospitalization = jsonObject?.hospitalization
      this.hospitalizationTimes = jsonObject?.hospitalizationTimes
      this.uti = jsonObject?.uti
      this.utiTimes = jsonObject?.utiTimes
      this.ventilation = jsonObject?.ventilation
      this.ventilationTimes = jsonObject?.ventilationTimes
      this.pcr = jsonObject?.pcr
      this.pcrTimes = jsonObject?.pcrTimes
      this.medications = jsonObject?.medications
      this.medicationsDescription = jsonObject?.medicationsDescription
      this.observations = jsonObject?.observations
      this.questionsOrDoubts = jsonObject?.questionsOrDoubts
    }
  }
}
</script>

<style lang="scss" scoped>
#active-clinical-case {
  width: 100%;

  .go-back {
    position: fixed;
    bottom: 100px;
    right: 40px;
    cursor: pointer;
    color: $grayDark;
    display: flex;
    align-items: center;

    span {
      margin-left: 5px;
      transition: 0.5s;

      &:hover {
        text-decoration: underline;
        color: $grayDark;
      }
    }

    i {
      background: $green-500;
      color: white;
      border-radius: 19%;
      margin-left: 5px;
    }
  }
}

.full-width {
  width: 100%;
  padding-bottom: 15px;
}

.side-by-side {
  display: flex;
  flex-wrap: wrap;
}

.half-width {
  flex: 1;
  margin-bottom: 10px;
}

.with-margin {
  margin-left: 20px;
}

.content-subtitle {
  flex-direction: column;
  align-items: left;
  text-align: left;
  display: flex;
  padding: 10px 20px;

  .title {
    color: $green-500;
  }
}

.content-title {
  flex-direction: column;
  margin-bottom: 25px;
  align-items: left;
  text-align: left;
  display: flex;
  padding: 30px 20px 0 20px;

  .title {
    color: $green-500;
  }

  .line {
    background-color: $green-500;
    margin-top: 15px;
    bottom: -15px;
    width: 60px;
    height: 5px;
  }
}

.btn {
  padding: 10px 0 20px 0;
  display: flex;
  place-content: end;

  .save {
    width: 150px;
  }

  .send {
    width: 250px;
  }
}

label {
  height: 14px;
  margin: 10px 0;
  font-size: 14px;
  font-weight: 600;
  color: $grayDark;
}

.intro-doc {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;

  p {
    text-align: justify;
    font-size: 14px;
    font-weight: 600;
    color: $grayDark;
  }
}

.filepath {
  display: flex;
  align-items: center;
  margin: 20px;

  .filename {
    font-size: 14px;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      border-bottom: 1px solid #000;
    }
  }
}
</style>
